"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAPHedgingProgramBarChart = exports["default"] = void 0;
var _chart = require("chart.js");
var _chartjsPluginAnnotation = _interopRequireDefault(require("chartjs-plugin-annotation"));
var _accounting = _interopRequireDefault(require("accounting"));
var _currencySymbolMap = _interopRequireDefault(require("currency-symbol-map"));
var _react = require("react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Dataset = /*#__PURE__*/function (Dataset) {
  Dataset[Dataset["Actuals"] = 0] = "Actuals";
  Dataset[Dataset["Overhedged"] = 1] = "Overhedged";
  Dataset[Dataset["Underhedged"] = 2] = "Underhedged";
  Dataset[Dataset["Forecasted"] = 3] = "Forecasted";
  Dataset[Dataset["Program"] = 4] = "Program";
  return Dataset;
}(Dataset || {});
var useAPHedgingProgramBarChart = function useAPHedgingProgramBarChart(currencyCode, text, editCallback, onBarClick, isWidget, europeanLocale) {
  _chart.Chart.register(_chartjsPluginAnnotation["default"]);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    hoveringEditButton = _useState2[0],
    setHoveringEditButton = _useState2[1];
  var defaultDash = [16, 10];
  function toggleOverhedgedAmountTooltip(chart, id, show) {
    var _chart$options, _chart$options$plugin, _chart$options$plugin2;
    if ((_chart$options = chart.options) !== null && _chart$options !== void 0 && (_chart$options$plugin = _chart$options.plugins) !== null && _chart$options$plugin !== void 0 && (_chart$options$plugin2 = _chart$options$plugin.annotation) !== null && _chart$options$plugin2 !== void 0 && _chart$options$plugin2.annotations) {
      var button = chart.options.plugins.annotation.annotations[id + '_overhedged_tooltip'];
      if (button) {
        button.display = show;
        chart.options.plugins.annotation.annotations[id + '_overhedged_tooltip'] = button;
      }
      if (show) {
        chart.update();
      }
    }
  }
  var basicOptions = {
    animation: {
      duration: 1000
    },
    maintainAspectRatio: false,
    onHover: function onHover(event, elements, chart) {
      if (elements.length === 0) {
        chart.update();
      }
      if (elements && elements.length > 0) {
        var _index = elements[0].index;
        var _datasetIndex = elements[0].datasetIndex;
        if (Dataset.Overhedged === _datasetIndex) {
          toggleOverhedgedAmountTooltip(chart, _index.toString(), true);
        } else {
          toggleOverhedgedAmountTooltip(chart, _index.toString(), false);
        }
      }
    },
    onClick: function onClick(event, elements, chart) {
      if (elements && elements.length > 0 && onBarClick && !hoveringEditButton) {
        var _index2 = elements[0].index;
        var _datasetIndex2 = elements[0].datasetIndex;
        onBarClick(_index2, _datasetIndex2);
      }
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
          borderWidth: 0,
          drawTicks: false
        },
        ticks: {
          padding: 10,
          color: 'rgba(52,52,52, 0.6)'
        },
        stacked: true,
        labels: [] // avarageRates
      },

      x2: {
        grid: {
          display: false,
          drawBorder: true,
          borderWidth: 1,
          drawTicks: false
        },
        ticks: {
          padding: 10,
          color: 'rgba(52,52,52, 0.6)'
        },
        stacked: true,
        labels: [] // periodNames
      },

      y: {
        ticks: {
          display: false
        }
      }
    },
    plugins: {
      legend: {
        maxWidth: 500,
        position: isWidget ? 'left' : 'bottom',
        labels: {
          boxWidth: 13,
          padding: 45
          // filter(item, chart): boolean {
          //     // Hide remaining item in legend
          //     return !item.text.includes('Remaining');
          // },
        },

        onClick: function onClick(e) {
          var _e$native;
          return (_e$native = e["native"]) === null || _e$native === void 0 ? void 0 : _e$native.stopPropagation();
        }
      },
      tooltip: {
        enabled: false
      },
      annotation: {
        annotations: {}
      }
    }
  };
  var select = function select(element, period) {
    if (editCallback && period.id) {
      editCallback(period.id);
    }
    return true;
  };
  var forecastLabel = function forecastLabel(index, period) {
    return {
      type: 'label',
      xValue: index,
      yValue: period.forecast,
      position: {
        x: 'center',
        y: 'start'
      },
      yAdjust: -24,
      padding: 0,
      color: '#485F8B',
      content: ["".concat((0, _currencySymbolMap["default"])(currencyCode)).concat(_accounting["default"].format(period.forecast, 2, europeanLocale ? '.' : ',', europeanLocale ? ',' : '.'))]
    };
  };
  var totalHedgedLabel = function totalHedgedLabel(index, period, chartType) {
    var displayValue = '';
    if (chartType === 'amount') {
      displayValue = "".concat((0, _currencySymbolMap["default"])(currencyCode)).concat(_accounting["default"].format(period.totalHedged, 2, europeanLocale ? '.' : ',', europeanLocale ? ',' : '.'));
    } else {
      displayValue = "".concat(Math.round(period.totalHedged / period.programAmount * 100), "%");
    }
    return {
      type: 'label',
      xValue: index,
      yValue: 0,
      position: {
        x: 'center',
        y: 'end'
      },
      yAdjust: -10,
      padding: 0,
      color: '#ffffff',
      content: [displayValue]
    };
  };
  function toggleLabel(ctx, show) {
    var _chart$options2, _chart$options2$plugi, _chart$options2$plugi2;
    var chart = ctx.chart;
    if ((_chart$options2 = chart.options) !== null && _chart$options2 !== void 0 && (_chart$options2$plugi = _chart$options2.plugins) !== null && _chart$options2$plugi !== void 0 && (_chart$options2$plugi2 = _chart$options2$plugi.annotation) !== null && _chart$options2$plugi2 !== void 0 && _chart$options2$plugi2.annotations) {
      var _ctx$element$label, _ctx$element$label$op, _ctx$element, _ctx$element$options;
      var _id = ((_ctx$element$label = ctx.element.label) === null || _ctx$element$label === void 0 ? void 0 : (_ctx$element$label$op = _ctx$element$label.options) === null || _ctx$element$label$op === void 0 ? void 0 : _ctx$element$label$op.id) || ((_ctx$element = ctx.element) === null || _ctx$element === void 0 ? void 0 : (_ctx$element$options = _ctx$element.options) === null || _ctx$element$options === void 0 ? void 0 : _ctx$element$options.id);
      var button = chart.options.plugins.annotation.annotations[_id + '_button'];
      button.display = show;
      chart.options.plugins.annotation.annotations[_id + '_button'] = button;
      if (show) {
        chart.update();
      }
    }
  }
  var forecastEditArea = function forecastEditArea(index, period) {
    return {
      type: 'box',
      xMin: index - 0.35,
      xMax: index + 0.35,
      yMin: 0,
      yMax: period.forecast,
      borderWidth: 0,
      drawTime: 'afterDatasetsDraw',
      backgroundColor: 'transparent',
      enter: function enter(context) {
        toggleLabel(context, true);
      },
      leave: function leave(context) {
        toggleLabel(context, false);
      }
    };
  };
  var forecastEditButton = function forecastEditButton(index, editForecastText, period) {
    return {
      type: 'label',
      xValue: index + 0.32,
      drawTime: 'afterDatasetsDraw',
      borderRadius: 4,
      yValue: period.forecast,
      yAdjust: 40,
      display: false,
      position: {
        x: 'end',
        y: 'end'
      },
      padding: {
        x: 12,
        y: 8
      },
      font: {
        weight: '200',
        size: 10,
        lineHeight: 1.1,
        family: 'Arial',
        style: 'inherit'
      },
      borderColor: 'transparent',
      color: '#333',
      backgroundColor: 'rgba(255, 255,255 ,0.3)',
      content: ["\u270E  ".concat(editForecastText)],
      click: function click(context, event) {
        select(context.element, period);
      },
      enter: function enter(context) {
        context.element.options.borderWidth = 1;
        context.element.options.borderColor = 'rgba(230, 230, 230,0.5)';
        setHoveringEditButton(true);
      },
      leave: function leave(context) {
        context.element.options.borderWidth = 0;
        context.chart.update();
        setHoveringEditButton(false);
      }
    };
  };
  var overHedgedAmountTooltip = function overHedgedAmountTooltip(index, period, currencyCode) {
    var tooltipBackgroundColor = 'rgba(0,0,0,0.8)';
    var xMin = index;
    var xMax = index;
    var arrowStartY = period.programAmount - period.totalToHedge / 2;
    var arrowEndY = period.programAmount - period.totalToHedge / 2 - 1; // defines arrow direction

    return {
      drawTime: 'afterDraw',
      borderColor: tooltipBackgroundColor,
      borderDash: [0, 0],
      borderWidth: 2,
      yMin: arrowStartY,
      yMax: arrowEndY,
      type: 'line',
      xMin: xMin,
      xMax: xMax,
      display: false,
      arrowHeads: {
        start: {
          length: 4,
          width: 4,
          fill: true,
          display: true
        }
      },
      label: {
        backgroundColor: tooltipBackgroundColor,
        backgroundShadowColor: tooltipBackgroundColor,
        color: '#ffffff',
        textAlign: 'center',
        padding: {
          left: 10,
          right: 10,
          top: 6,
          bottom: 6
        },
        yAdjust: 18,
        height: 12,
        borderRadius: 4,
        position: 'center',
        display: true,
        font: {
          weight: '200',
          size: 8,
          lineHeight: 2,
          family: 'inherit',
          style: 'inherit'
        },
        content: ["".concat((0, _currencySymbolMap["default"])(currencyCode)).concat(_accounting["default"].format(period.totalHedged - period.programAmount, 2, europeanLocale ? '.' : ',', europeanLocale ? ',' : '.'), " ").concat(text.overhedged.toLocaleLowerCase())]
      }
    };
  };
  var programMarker = function programMarker(index, period, currencyCode, chartType) {
    var hedgingDescription = function hedgingDescription(programAmount, hedgedAmount, hedgingCurrencyCode) {
      if (hedgedAmount < programAmount) {
        if (chartType === 'amount') {
          return "".concat((0, _currencySymbolMap["default"])(hedgingCurrencyCode)).concat(_accounting["default"].format(programAmount - hedgedAmount, 2, europeanLocale ? '.' : ',', europeanLocale ? ',' : '.'));
        }
        return "".concat(Math.round((programAmount - hedgedAmount) / programAmount * 100), "%");
      } else if (hedgedAmount === programAmount) {
        return '';
      } else {
        if (chartType === 'amount') {
          return "".concat((0, _currencySymbolMap["default"])(hedgingCurrencyCode)).concat(_accounting["default"].format(hedgedAmount - programAmount, 2, europeanLocale ? '.' : ',', europeanLocale ? ',' : '.'));
        }
        return "".concat(Math.round((hedgedAmount - programAmount) / programAmount * 100), "%");
      }
    };
    var xMin = index - 0.35;
    var xMax = index + 0.35;
    var isOverhedged = period.totalHedged > period.programAmount;
    return {
      drawTime: 'afterDraw',
      borderColor: '#485F8B',
      borderDash: defaultDash,
      borderWidth: 2,
      yMin: period.programAmount,
      // target
      yMax: period.programAmount,
      // target
      type: 'line',
      xMin: xMin,
      xMax: xMax,
      label: {
        backgroundColor: 'transparent',
        color: period.totalToHedge < 0 ? '#ffffff' : '#485F8B',
        textAlign: 'center',
        padding: 4,
        yAdjust: isOverhedged ? -12 : 12,
        // Shows on top for overhedged
        borderRadius: 4,
        position: 'center',
        display: true,
        font: {
          weight: '200',
          size: 11,
          lineHeight: 11,
          family: 'inherit',
          style: 'inherit'
        },
        content: [isOverhedged ? '' : hedgingDescription(period.programAmount, period.totalHedged, currencyCode)]
      }
    };
  };
  var mapDataToChartOptions = function mapDataToChartOptions(rawData, chartType) {
    var _basicOptions$scales, _options$scales, _options$scales2, _options$plugins, _options$plugins$anno;
    var options = basicOptions;
    if ((_basicOptions$scales = basicOptions.scales) !== null && _basicOptions$scales !== void 0 && _basicOptions$scales.y) {
      basicOptions.scales.y = _objectSpread(_objectSpread({}, basicOptions.scales.y), {}, {
        suggestedMax: Math.max.apply(null, rawData.map(function (item) {
          return item.forecast;
        })) * 1.15
      });
    }
    if ((_options$scales = options.scales) !== null && _options$scales !== void 0 && _options$scales.x) {
      options.scales.x = _objectSpread(_objectSpread({}, options.scales.x), {}, {
        labels: rawData.map(function (item) {
          return _accounting["default"].format(item.weightedAverageRate, 6, europeanLocale ? '.' : ',', europeanLocale ? ',' : '.');
        })
      });
    }
    if ((_options$scales2 = options.scales) !== null && _options$scales2 !== void 0 && _options$scales2.x2) {
      options.scales.x2 = _objectSpread(_objectSpread({}, options.scales.x2), {}, {
        labels: rawData.map(function (item) {
          return item.period;
        })
      });
    }
    var markerAnnotations = {};
    var forecastlabelAnnotations = {};
    var totalHedgedlabelAnnotations = {};
    var forecastEditButtonAnnotations = {};
    var forecastEditAreaAnnotations = {};
    var overHedgedTooltipAnnotations = {};
    for (var i = 0; i < rawData.length; i++) {
      var period = rawData[i];
      markerAnnotations["".concat(period.id, "_program")] = programMarker(i, period, currencyCode, chartType);
      forecastlabelAnnotations["".concat(period.id, "_forecast_label")] = forecastLabel(i, period);
      forecastEditButtonAnnotations["".concat(period.id, "_forecast_edit_button")] = forecastEditButton(i, text.editForecast, period);
      totalHedgedlabelAnnotations["".concat(period.id, "_total_hedged_label")] = totalHedgedLabel(i, period, chartType);
      forecastEditAreaAnnotations["".concat(period.id, "_forecast_edit")] = forecastEditArea(i, period);
      var isOverhedged = period.totalHedged > period.programAmount;
      if (isOverhedged) {
        overHedgedTooltipAnnotations["".concat(i, "_overhedged_tooltip")] = overHedgedAmountTooltip(i, period, currencyCode);
      }
    }

    // Add annotations
    if ((_options$plugins = options.plugins) !== null && _options$plugins !== void 0 && (_options$plugins$anno = _options$plugins.annotation) !== null && _options$plugins$anno !== void 0 && _options$plugins$anno.annotations) {
      options.plugins.annotation.annotations = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, markerAnnotations), forecastlabelAnnotations), forecastEditAreaAnnotations), totalHedgedlabelAnnotations), forecastEditButtonAnnotations), overHedgedTooltipAnnotations);
    }
    return options;
  };
  var mapDataToChartData = function mapDataToChartData(rawData, chartType) {
    var chartData = {
      labels: [],
      datasets: [{
        label: text.actuals,
        data: [],
        // hedgedAmount
        backgroundColor: '#1E8777',
        barPercentage: 0.6,
        stack: 'Hedging',
        xAxisID: 'x',
        datalabels: {
          display: false
        }
      }, {
        label: text.overhedged,
        data: [],
        // OverHedged
        backgroundColor: '#d64a4a',
        barPercentage: 0.6,
        stack: 'Hedging',
        xAxisID: 'x',
        datalabels: {
          display: false
        }
      }, {
        label: text.underhedged,
        data: [],
        // Underhedged
        backgroundColor: '#c9c7c9',
        barPercentage: 0.6,
        stack: 'Hedging',
        xAxisID: 'x',
        datalabels: {
          display: false
        }
      }, {
        label: text.forecasted,
        data: [],
        // forecastAmount
        backgroundColor: 'rgba(0, 118, 170, 0.2)',
        barPercentage: 0.9,
        stack: 'forcast',
        xAxisID: 'x2',
        datalabels: {
          display: false
        }
      }, {
        label: text.program,
        backgroundColor: '#485F8B',
        barThickness: 0,
        xAxisID: 'axis3',
        data: [],
        datalabels: {
          display: false
        }
      }]
    };
    var _iterator = _createForOfIteratorHelper(rawData),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var period = _step.value;
        if (period.totalToHedge < 0) {
          chartData.datasets[Dataset.Actuals].data.push(period.totalHedged + period.totalToHedge);
          chartData.datasets[Dataset.Overhedged].data.push(Math.abs(period.totalToHedge));
          chartData.datasets[Dataset.Underhedged].data.push(0);
        } else {
          chartData.datasets[Dataset.Actuals].data.push(period.totalHedged);
          chartData.datasets[Dataset.Overhedged].data.push(0);
          chartData.datasets[Dataset.Underhedged].data.push(Math.abs(period.totalToHedge));
        }
        chartData.datasets[Dataset.Forecasted].data.push(period.forecast);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return chartData;
  };
  return {
    mapDataToChartOptions: mapDataToChartOptions,
    mapDataToChartData: mapDataToChartData,
    programMarker: programMarker
  };
};
exports.useAPHedgingProgramBarChart = useAPHedgingProgramBarChart;
var _default = useAPHedgingProgramBarChart;
exports["default"] = _default;